/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { Box, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../style/Table.style";
import { SyncLoader } from "react-spinners";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { toast, ToastContainer, Zoom } from "react-toastify";

const EditUserLevel = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const userLevelData = useSelector((state) => state.Modal.val);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("ug_level_id", userLevelData.ug_level_id);
    formData.append("ugleve_name", data.ugleve_name);
    formData.append("active_fg", data.active_fg);

    fetch(`${process.env.REACT_APP_API_URL}/api/updateLevel`, {
      // fetch(`http://192.168.0.173/kyamch_ctms_backend_qa/api/updateLevel`, {
      method: "POST",
      body: formData,
      // headers: {
      //   "content-type": "application/json",
      // },

      // body: JSON.stringify({
      //   date_of_registration: reg,
      //   full_name: data.full_name,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // console.log("data", data);
        if (data.success === true) {
          dispatch(handleEditClose());
        } else if (data.duplicate === true) {
          toast.error("User Level is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
          // alert("User Level is already exists!!");
        }
      })
      .finally(() => setIsLoading(false));
    // dispatch(handleAddClose());
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <Box mb="20px">
          <TextField
            defaultValue={userLevelData.ugleve_name}
            size="small"
            fullWidth
            label="User level Name*"
            variant="outlined"
            {...register("ugleve_name", {
              required: true,
              pattern: /^[a-zA-Z]+$/,
            })}
          />
          {errors?.ugleve_name?.type === "required" && (
            <ErrorMessage>User level Name is required*</ErrorMessage>
          )}
          {errors?.ugleve_name?.type === "pattern" && (
            <ErrorMessage>
              Should not allow inserting any symbol and number
            </ErrorMessage>
          )}
        </Box>
        <Box>
          <TextField
            select
            defaultValue={userLevelData.active_fg}
            size="small"
            fullWidth
            label="Active Status"
            variant="outlined"
            {...register("active_fg", { required: true })}
          >
            <MenuItem value="Y">Active</MenuItem>
            <MenuItem value="N">Inactive</MenuItem>
          </TextField>
          {errors?.active_fg?.type === "required" && (
            <ErrorMessage>Active status is required*</ErrorMessage>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            Update User Level
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />

        {/* <ThemButton type="submit">Add User Level</ThemButton> */}
      </Box>
    </form>
  );
};

export default EditUserLevel;
